import { render, staticRenderFns } from "./mod6-1.vue?vue&type=template&id=79c83c1e&scoped=true&"
import script from "./mod6-1.vue?vue&type=script&lang=js&"
export * from "./mod6-1.vue?vue&type=script&lang=js&"
import style0 from "./mod6-1.vue?vue&type=style&index=0&id=79c83c1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c83c1e",
  null
  
)

export default component.exports